import { FormData } from '../types';

/**
 * Handles communication with Odoo CRM via JSON-RPC.
 * Required Environment Variables (set in Vercel):
 * VITE_ODOO_URL: Your Odoo instance URL
 * VITE_ODOO_DB: Your database name
 * VITE_ODOO_API_KEY: Your API key
 * VITE_ODOO_USER: Your username/email
 */

export const postToOdoo = async (data: FormData): Promise<boolean> => {
  try {
    // Fix: Cast import.meta to any to access environment variables in a Vite environment
    const env = (import.meta as any).env;
    const odooUrl = env.VITE_ODOO_URL || '';
    const db = env.VITE_ODOO_DB || '';
    const username = env.VITE_ODOO_USER || '';
    const password = env.VITE_ODOO_API_KEY || '';

    if (!odooUrl || !db || !username || !password) {
      console.warn("Odoo environment variables are not set correctly. Please prefix them with VITE_ in Vercel.");
      await new Promise(resolve => setTimeout(resolve, 1500));
      return true;
    }

    const leadData = {
      name: `طلب تمويل رمضان 2026: ${data.fullName}`,
      contact_name: data.fullName,
      mobile: data.phone,
      city: data.city,
      description: `
        نوع السيارة: ${data.vehicleType}
        القيمة التقريبية: ${data.approxPrice}
        وقت التواصل المفضل: ${data.preferredTime}
        الحملة: عرض رمضان 2026 - 4.5% ثابت
      `,
      type: 'lead',
    };

    const response = await fetch(`${odooUrl}/jsonrpc`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        jsonrpc: '2.0',
        method: 'call',
        params: {
          service: 'object',
          method: 'execute_kw',
          args: [db, username, password, 'crm.lead', 'create', [leadData]]
        }
      })
    });

    const result = await response.json();
    return !result.error;
  } catch (error) {
    console.error("Failed to post to Odoo:", error);
    return false;
  }
};